<template>
  <div
    id="click_log_page"
    class="card"
  >
    <b-card-header>
      <ps-filters
        v-model="filterValues"
        :filter-settings="filterSettings"
        :show-export="$hasPermission('export_click_logs')"
        @search="search"
        @exportToCSV="exportToCSV"
      />
    </b-card-header>
    <div class="table-responsive mb-0">
      <table
        role="table"
        class="table b-table table-striped table-hover"
      >
        <thead
          role="rowgroup"
          class=""
        >
          <tr
            role="row"
            class=""
          >
            <th
              role="columnheader"
              aria-colindex="1"
              :aria-sort="arialSort('hash')"
              @click="sortCol('hash')"
            >
              {{ $t('logs.hash') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="2"
              :aria-sort="arialSort('external_user_id')"
              @click="sortCol('external_user_id')"
            >
              {{ $t('logs.yourUserId') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="2"
            >
              {{ $t('logs.app') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('length_of_interview')"
              @click="sortCol('length_of_interview')"
            >
              {{ $t('logs.loi') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('result')"
              @click="sortCol('result')"
            >
              {{ $t('logs.result') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('publisher_payout')"
              @click="sortCol('publisher_payout')"
            >
              {{ $t('logs.payout') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('reward')"
              @click="sortCol('reward')"
            >
              {{ $t('logs.reward') }}
            </th>
            <th
              role="columnheader"
              aria-colindex="3"
              :aria-sort="arialSort('created_at')"
              @click="sortCol('created_at')"
            >
              {{ $t('logs.dateTime') }}
            </th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          <template v-for="(rowTr, indextr) in items">
            <tr
              :key="indextr"
              :class="rowTr.class"
            >
              <td>
                {{ rowTr.hash }}
              </td>
              <td>
                {{ rowTr.external_user_id }}
              </td>
              <td>
                <app-link :app="{ hash: rowTr.app_hash, app_name: rowTr.app_name }" />
              </td>
              <td>
                {{ rowTr.loi | Hms('') }}
              </td>
              <td :class="`text-${rowTr.statusClass}`">
                {{ systemLabel(rowTr.status) }}
              </td>
              <td class="text-success">
                <template v-if="rowTr.publisher_payout !== 0">
                  {{ rowTr.publisher_payout | formatCurrency }}
                </template>
              </td>
              <td>
                {{ rowTr.user_reward }}
              </td>
              <td>
                {{ rowTr.created_at | dotDateTimeShort }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <b-card-footer>
      <b-row>
        <b-col
          v-show="items.length > 0"
          cols="12"
        >
          <pagination-and-table-info
            :data="paginationData"
            @change="handleChangePage($event)"
          />
        </b-col>
        <b-col
          v-show="items.length === 0"
          cols="12"
          style="font-weight: 500; text-align: center"
        >
          {{ $t('apps.noData') }}
        </b-col>
      </b-row>
    </b-card-footer>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'
import { systemLabel } from '@/libs/i18n/display'

import PaginationAndTableInfo from '@ps_main/custom-components/PaginationAndTableInfo.vue'
import PsFilters from '@ps_main/custom-components/PsFilters.vue'
import AppLink from '@ps_main/custom-components/AppLink.vue'

export default {
  components: {
    AppLink,
    PaginationAndTableInfo,
    PsFilters,
  },
  data() {
    return {
      url: '/api/logs/click-log',
      params: {
        page: 1,
        orderBy: 'id',
        itemPerPage: 500,
        orderDirection: 'desc',
        initFilter: 0,
      },
      items: [],
      responseData: null,
      filterValues: {},
      filterSettings: {
        dateRange: {
          type: 'daterange',
          get label() { return i18n.t('logs.fromTo') },
          class: 'mr-2 mb-0',
          style: '',
          data: [],
          defaultValue: {
            fromDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
            toDate: new Date(),
          },
          postKey: 'dateRange',
          'label-cols': 2,
        },
        app: {
          type: 'select',
          get label() { return i18n.t('apps.appName') },
          class: 'mr-2 mb-0',
          style: 'width: 320px;',
          data: [],
          defaultData: { value: 0, get text() { return i18n.t('logs.allApps') } },
          defaultValue: 0,
          postKey: 'app',
          'label-cols': 4,
        },
        status: {
          type: 'select',
          get label() { return i18n.t('apps.status') },
          class: 'mr-2 mb-0',
          style: 'width: 320px;',
          data: [],
          defaultData: { value: 0, get text() { return i18n.t('logs.allStatuses') } },
          defaultValue: 0,
          postKey: 'status',
          'label-cols': 3,
        },
      },
    }
  },
  computed: {
    paginationData() {
      return this.laravelPaginationPages(this.responseData)
    },
  },
  created() {
    Object.keys(this.filterSettings).forEach(property => {
      if (
        Array.isArray(this.filterSettings[property].data)
          && this.filterSettings[property].defaultData !== undefined
      ) {
        this.filterSettings[property].data.push(this.filterSettings[property].defaultData)
      }
    })
  },
  methods: {
    systemLabel,
    handleChangePage(page) {
      this.params.page = page
      this.search()
    },
    sortCol(fieldName) {
      if (this.params.orderBy === fieldName) {
        this.params.orderDirection = this.params.orderDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.params.orderBy = fieldName
        this.params.orderDirection = 'asc'
      }
      this.search()
    },
    arialSort(sortFieldName) {
      if (this.params.orderBy === sortFieldName) {
        return this.params.orderDirection === 'asc'
          ? 'ascending'
          : 'descending'
      }
      return 'none'
    },
    search() {
      this.showLoading()
      this.$http
        .get(`${this.url}/get`, {
          params: {
            ...this.params,
            ...this.filterValues,
          },
        })
        .then(response => {
          const responseData = response.data
          this.items = responseData.data
          this.responseData = responseData
          this.initiateFilters(responseData)
        })
        .catch(errors => {
          this.items = []
          this.responseData = null
          this.alertApiError(errors, i18n.t('logs.clickLogRequestFailed'))
        })
        .finally(() => {
          this.hideLoading()
        })
    },
    initiateFilters(responseData) {
      if (
        this.params.initFilter === 0
          && typeof responseData.filterData !== 'undefined'
      ) {
        Object.keys(responseData.filterData).forEach(property => {
          if (typeof this.filterSettings[property] === 'object') {
            if (this.filterSettings[property].defaultData !== undefined) {
              this.filterSettings[property].data = [
                ...[this.filterSettings[property].defaultData],
                ...responseData.filterData[property],
              ]
            } else {
              this.filterSettings[property].data = responseData.filterData[property]
            }
          }
        })

        this.params.initFilter = 1
      }
    },
    exportToCSV() {
      const exportLocale = i18n.locale
      this.isBusy = true
      this.showLoading()
      this.$http
        .get(`${this.url}/export`, {
          params: {
            ...this.params,
            ...this.filterValues,
            locale: exportLocale,
            only_file_name: true,
          },
        })
        .then(response => {
          const filename = response.data

          return this.$http
            .get(`${this.url}/export`, {
              params: {
                ...this.params,
                ...this.filterValues,
                locale: exportLocale,
              },
              responseType: 'blob',
            })
            .then(responseExport => {
              const url = window.URL.createObjectURL(new Blob([responseExport.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', filename)
              document.body.appendChild(link)
              link.click()
            })
            .catch(errors => {
              this.alertApiError(errors, i18n.t('logs.clickLogExportFailed'))
            })
        })
        .catch(errors => {
          this.alertApiError(errors, i18n.t('logs.clickLogExportFailed'))
        })
        .finally(() => {
          this.hideLoading()
          this.isBusy = false
        })
    },
  },
}
</script>
